import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

export function readBoardCollaborators(
  params: OpalApiRequestParams<'ReadBoardCollaboratorsV3'>
): Promise<OpalApiResponseDocument<'ReadBoardCollaboratorsV3', 200>> {
  const url = new URL(`/board_collaborators/v3`, window.location.origin)

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
